import { BaseIcon, BaseIconProps } from '../BaseIcon';

export type PinnedIconProps = Omit<BaseIconProps, 'children'>;

export const PinnedIcon = ({ ...props }: PinnedIconProps) => (
  <BaseIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M17 4H7C6.45 4 6 4.45 6 5C6 5.55 6.45 6 7 6H8V11C8 12.66 6.66 14 5 14V16H10.97V20L11.97 21L12.97 20V16H19V14C17.34 14 16 12.66 16 11V6H17C17.55 6 18 5.55 18 5C18 4.45 17.55 4 17 4Z"
      stroke="none"
    />
  </BaseIcon>
);

PinnedIcon.displayName = 'PinnedIcon';
